import { apiHelper } from "../utils/apiHelper";

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/theme-colors`;
const API_URL_PUBLIC = `${process.env.REACT_APP_API_URL}/api/admin/theme-colors-bulk`;

export const fetchColors = async ({
  organization_id,
  page = 1,
  search = "",
  limit = 10,
  token,
}) => {
  const query = new URLSearchParams({
    organization_id,
    page,
    search,
    limit,
  }).toString();
  const response = await apiHelper(`${API_URL}?${query}`, "GET", null, {
    Authorization: `Bearer ${token}`,
  });
  return {
    data: response.data || [],
    total_records:
      response.total_records || (response.data ? response.data.length : 0),
    url: response.url || API_URL,
  };
};
export const createColor = (payload) =>
  apiHelper(API_URL_PUBLIC, "POST", payload);
// export const fetchColor = (colorId) =>
//   apiHelper(`${API_URL}/${colorId}`, "GET");
// export const modifyColor = (colorId, payload) =>
//   apiHelper(`${API_URL}/${colorId}`, "PUT", payload);
// export const deleteColor = (colorId) =>
//   apiHelper(`${API_URL}/${colorId}`, "DELETE");
